<template>
  <div>
    <v-select
      v-if="typeof selectModel === 'object'"
      v-model="localSelectModal"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :options="selectOptions"
      :reduce="val => val.value"
      :clearable="false"
      multiple
      @input="toShow && toShow === 'file-categories' ? fileCategoriesChange() : ''"
    />
    <v-select
      v-else
      v-model="localSelectModal"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :options="selectOptions"
      :reduce="val => val.value"
      :clearable="false"
      @input="templateChange"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
} from 'bootstrap-vue'
import { EventBus } from '@/event-bus'
import axios from '@axios'

export default {
  inject: ['sharedState'], // Inject the reactive shared state
  components: {
    vSelect,
  },
  props: {
    selectModel: {
      type: [String, Number, Array, Object],
      required: true,
      default: '',
    },
    selectOptions: {
      type: Array,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    moduleID: {
      type: Number,
      default: 0,
      required: false,
    },
    toShow: {
      type: String,
      default: '',
      required: false,
    },
    dependsOn: {
      type: [String, Number],
      default: null,
      required: false,
    },
  },
  data() {
    return {
      localSelectModal: this.selectModel,
    }
  },
  watch: {
    'sharedState.apiLetterData': {
      handler() {
        if (this.field.label === 'Select Letter Template') {
          this.selectOptions = this.sharedState.apiLetterData
        }
      },
    },
  },
  created() {
    if (this.field && this.field.dynamic_values) {
      if (this.field && this.field.label === 'Select Module') {
        this.getModules()
      }
    }
  },
  methods: {
    fileCategoriesChange() {
      EventBus.$emit('fileCategoriesChnage', this.localSelectModal)
    },
    async getModules() {
      const processID = this.$route.params.id
      await axios.get(`/process/get-previous-modules/${Number(processID)}`).then(response => {
        if (response.status === 200) {
          this.selectOptions = response.data.data
          console.log('this.selectOptions ', this.selectOptions)
        }
      }).catch(error => console.log(error))
    },
    templateChange(evt) {
      const obj = {
        id: evt,
        sectionID: `section-${this.moduleID}`,
        dependsOn: this.dependsOn,
      }
      EventBus.$emit('changeCopyModuleTemplateVariable', obj)
    },
  },
}
</script>

      <style lang="scss">
        @import '@core/scss/vue/libs/vue-select.scss';
        .dropdownModuleFields {
          width: 50%;
        }
      </style>
